
import { useEffect, useRef, useState } from "react";
import { InstallationCode } from "./installation/InstallationCode";
import { InstallationInstructions } from "./installation/InstallationInstructions";
import { InstallationTest } from "./installation/InstallationTest";

interface PixelInstallationProps {
  pixelId: string;
  onTestPixel?: () => Promise<void>;
  onClose?: () => void;
}

export function PixelInstallation({ pixelId, onTestPixel, onClose }: PixelInstallationProps) {
  const [isReady, setIsReady] = useState(false);
  const mountedRef = useRef(true);
  const pixelIdRef = useRef<string | null>(null);
  
  // Store the pixelId in a ref to track changes
  useEffect(() => {
    pixelIdRef.current = pixelId;
  }, [pixelId]);

  useEffect(() => {
    // Set component as mounted
    mountedRef.current = true;
    
    // Slight delay to ensure component is fully ready
    const timer = setTimeout(() => {
      if (mountedRef.current && pixelIdRef.current === pixelId) {
        setIsReady(true);
      }
    }, 100);
    
    return () => {
      clearTimeout(timer);
      mountedRef.current = false;
    };
  }, [pixelId]);

  // Don't render if no pixel ID or component is unmounting
  if (!pixelId) {
    return null;
  }

  return (
    <div 
      className="space-y-6 pb-6" 
      data-pixel-id={pixelId} 
      data-ready={isReady}
      data-testid="pixel-installation"
    >
      <InstallationCode pixelId={pixelId} />
      <InstallationInstructions />
      {onTestPixel && <InstallationTest pixelId={pixelId} onTestPixel={onTestPixel} />}
    </div>
  );
}
